module.exports = __webpack_public_path__ + "img/paper.3ba3f94.svg";